import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { FormCd001ClassificacaoBuild } from './forms-build/form-cd001-build-classificacao';

export class FormCd001Classificacao extends FormCd001ClassificacaoBuild {
  public createFormClassificacao(formBuilder: FormBuilder): FormGroup {
    const formulario: FormGroup = formBuilder.group({
      id: [0, []],
      site: ['', []],
      data_hora: ['', []],
      numero_controle: ['', []],
      hibrido: ['', []],
      processo: ['', []],
      lote_origem: ['', []],
      lote_ds: ['', []],
      lote_cs: ['', []],
      origem: ['', []],
      // umidade_ds_prc: ['', []],
      safra: ['', []],
      peneira: ['', []],
      destino: ['', []],
      retido_peneira_treze_meio_prc: ['', []],
      retido_peneira_treze_prc: ['', []],
      retido_peneira_doze_meio_prc: ['', []],
      retido_peneira_doze_prc: ['', []],
      vazado_peneira_corresp_oblongo_prc: ['', []],
      retido_peneira_vinte_dois_prc: ['', []],
      retido_peneira_vinte_um_prc: ['', []],
      retido_peneira_vinte_prc: ['', []],
      retido_peneira_dezenove_prc: ['', []],
      retido_peneira_dezoito_prc: ['', []],
      retido_peneira_dezessete_prc: ['', []],
      retido_peneira_dezesseis_prc: ['', []],
      retido_peneira_quinze_prc: ['', []],
      retido_peneira_onze_meio_prc: ['', []],
      vazado_peneira_corresp_furo_redondo_prc: ['', []],
      resultado_retencao: ['', []],
      minimo_siaqs_mm: ['', []],
      maximo_siaqs_mm: ['', []],
      range_siaqs_mm: ['', []],
      desvio_padrao_siaqs_mm: ['', []],
      plantabilidade_siaqs_prc: ['', []],
      resultado_siaqs: ['', []],
      motivo_reprovacao_siaqs: ['', []],
      observacoes: ['', []],
      created_by: ['', []],
      usuario: ['', []],
      offline: true,
      basic: ['', []],
      // generation_id: ['', []],
      porcentagem_falha: ['', []],
      vazao: ['', []],
      responsavel_especial: ['', []],
      marca: ['', []],
      anel: ['', []],
      disco: ['', []],
      falha: ['', []],
      dupla: ['', []],
      singulacao: ['', []],
      retido_peneira_r3_prc: ['', []],

      disco_socidisco: ['', []],
      anel_socidisco: ['', []],
      disco_apollo: ['', []],
      anel_apollo: ['', []],
      prc_falha_socidisco: ['', []],
      prc_dupla_socidisco: ['', []],
      prc_singulacao_socidisco: ['', []],
      prc_falha_apollo: ['', []],
      prc_dupla_apollo: ['', []],
      prc_singulacao_apollo: ['', []],
      resultado_precision_planting: ['', []],
      motivo_reprovacao_precision_planting: ['', []],
      liberacao_especial: ['', []],
      motivo_liberacao_especial: ['', []],
      grafite: ['', []],
      disco_recomendado_image_socidisco_maxim: ['', []],
      disco_recomendado_image_socidisco_tsi: ['', []],
      disco_recomendado_image_apollo_maxim: ['', []],
      disco_recomendado_image_apollo_tsi: ['', []],

      responsavel_analise: ['', []],
      // revia_numero_passada_basica: ['', []],
      regulagem_passe: ['', []],
      // anel_apollo_precision_planting: ['', []],
      previa_numero_passada_basica: ['', []],
      responsavel_autorizacao_especial: ['', []],
      avaliacao_retencao: ['', []],
      avaliacao_precision_planting: ['', []],
      numero_campo: ['', []],
      linha_processamento: ['', []],
      classe_basica: ['', []],
      umidade_media: ['', []],
      geracao: ['', []],
      peneira_basica: ['', []],
      processo_basica: ['', []],
      turno: [null, []],
    });
    return formulario;
  }
}
